import { useState, useEffect, useCallback } from "react";

const SERVERS = [
  {no:1, name:"BL-PROD-Script",     ip:"10.0.1.18",  base:"/fsa-script-api",   hkey:"fsascript",  specs:{cpu:6, ram:30, disk:250},  type:"app"},
  {no:2, name:"BL-PROD-Docker-1",   ip:"10.0.1.19",  base:"/fsa-docker1-api",  hkey:"fsadocker1", specs:{cpu:4, ram:32, disk:150},  type:"app"},
  {no:3, name:"BL-PROD-RabbitMQ",   ip:"10.0.1.20",  base:"/fsa-rabbitmq-api", hkey:"fsarabbitmq",specs:{cpu:4, ram:32, disk:150},  type:"app"},
  {no:4, name:"BL-PROD-Kafka-ZK",   ip:"10.0.1.21",  base:"/fsa-kafkazk-api",  hkey:"fsakafkazk", specs:{cpu:2, ram:4,  disk:200},  type:"app"},
  {no:5, name:"BL-PROD-Events",     ip:"10.0.1.22",  base:"/fsa-events-api",   hkey:"fsaevents",  specs:{cpu:8, ram:32, disk:100},  type:"app"},
  {no:6, name:"BL-PROD-Config",     ip:"10.0.1.23",  base:"/fsa-config-api",   hkey:"fsaconfig",  specs:{cpu:2, ram:2,  disk:50},   type:"app"},
  {no:7, name:"BL-GPS-Prod",        ip:"10.0.1.24",  base:"/fsa-gps-api",      hkey:"fsagps",     specs:{cpu:4, ram:16, disk:350},  type:"app"},
  {no:8, name:"FSA-DB-Primary",     ip:"1.7.187.57", base:"/fsadb-api",        hkey:"fsadb",      specs:{cpu:16,ram:64, disk:3964}, type:"db"},
  {no:9, name:"FSA-DB-Secondary",   ip:"1.7.187.58", base:"/fsadb2-api",       hkey:"fsadb2",      specs:{cpu:16,ram:64, disk:3964}, type:"db"},
  {no:10,name:"FSA-DB-Tertiary",    ip:"1.7.187.59", base:"/fsadb3-api",       hkey:"fsadb3",      specs:{cpu:16,ram:64, disk:3964}, type:"db"},
];

const BASE = "";
const REFRESH = 30000;

function cls(p){ return p>=85?"#E24B4A":p>=70?"#EF9F27":"#1D9E75"; }

function Bar({ val }) {
  const p = Math.min(val||0, 100);
  return (
    <div style={{width:50,height:4,background:"rgba(255,255,255,0.1)",borderRadius:2,overflow:"hidden",display:"inline-block",verticalAlign:"middle",marginLeft:4}}>
      <div style={{width:`${p}%`,height:"100%",background:cls(val||0),borderRadius:2}}/>
    </div>
  );
}

function Pct({ val }) {
  if (val==null) return <span style={{color:"#555"}}>--</span>;
  return (
    <span>
      <span style={{color:cls(val),fontWeight:600,fontSize:12}}>{val.toFixed(1)}%</span>
      <Bar val={val}/>
    </span>
  );
}

function normDisk(d) {
  if (!d) return null;
  if (d.total_gb !== undefined) return d;
  if (d.total !== undefined) return {
    percent: d.percent,
    used_gb: Math.round(d.used/1073741824),
    total_gb: Math.round(d.total/1073741824),
  };
  return null;
}

function DiskCell({ m }) {
  const src = m?.disks || m?.disk || {};
  const root = normDisk(src["/"] || src["C:"]);
  const mnt  = normDisk(src["/mnt/apps"] || src["/data"] || src["D:"]);
  if (!root && !mnt) return <span style={{color:"#555",fontSize:11}}>--</span>;
  return (
    <div style={{display:"flex",flexDirection:"column",gap:4,minWidth:150}}>
      {root && (
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <span style={{fontSize:10,color:"#555",width:30,flexShrink:0}}>/ root</span>
          <div style={{width:40,height:4,background:"rgba(255,255,255,0.08)",borderRadius:2,overflow:"hidden",flexShrink:0}}>
            <div style={{width:`${Math.min(root.percent,100)}%`,height:"100%",background:cls(root.percent),borderRadius:2}}/>
          </div>
          <span style={{fontSize:10,fontWeight:600,color:cls(root.percent),flexShrink:0}}>{root.percent.toFixed(0)}%</span>
          <span style={{fontSize:10,color:"#555",whiteSpace:"nowrap"}}>{root.used_gb}/{root.total_gb}GB</span>
        </div>
      )}
      {mnt && (
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <span style={{fontSize:10,color:"#555",width:30,flexShrink:0}}>/mnt</span>
          <div style={{width:40,height:4,background:"rgba(255,255,255,0.08)",borderRadius:2,overflow:"hidden",flexShrink:0}}>
            <div style={{width:`${Math.min(mnt.percent,100)}%`,height:"100%",background:cls(mnt.percent),borderRadius:2}}/>
          </div>
          <span style={{fontSize:10,fontWeight:600,color:cls(mnt.percent),flexShrink:0}}>{mnt.percent.toFixed(0)}%</span>
          <span style={{fontSize:10,color:"#555",whiteSpace:"nowrap"}}>{mnt.used_gb}/{mnt.total_gb}GB</span>
        </div>
      )}
    </div>
  );
}

function AppPills({ services }) {
  const [expanded, setExpanded] = useState(false);
  if (!services?.length) return <span style={{color:"#555",fontSize:10}}>--</span>;
  const show = expanded ? services : services.slice(0,5);
  const more = services.length - 5;
  return (
    <div style={{display:"flex",flexWrap:"wrap",gap:3,alignItems:"center"}}>
      {show.map((s,i) => (
        <span key={i} style={{
          fontSize:10,padding:"1px 6px",borderRadius:8,whiteSpace:"nowrap",
          background:s.status==="running"?"rgba(29,158,117,0.12)":"rgba(226,75,74,0.12)",
          border:`0.5px solid ${s.status==="running"?"rgba(29,158,117,0.4)":"rgba(226,75,74,0.4)"}`,
          color:s.status==="running"?"#1D9E75":"#E24B4A",
        }}>
          {s.name.replace(/\s*\(.*\)/,"").substring(0,18)}
        </span>
      ))}
      {!expanded && more>0 && (
        <span onClick={()=>setExpanded(true)} style={{
          fontSize:10,padding:"1px 7px",borderRadius:8,cursor:"pointer",
          background:"rgba(99,102,241,0.12)",border:"0.5px solid rgba(99,102,241,0.4)",
          color:"#6366f1",whiteSpace:"nowrap"
        }}>+{more} more</span>
      )}
      {expanded && (
        <span onClick={()=>setExpanded(false)} style={{
          fontSize:10,padding:"1px 7px",borderRadius:8,cursor:"pointer",
          background:"rgba(99,102,241,0.12)",border:"0.5px solid rgba(99,102,241,0.4)",
          color:"#6366f1"
        }}>less</span>
      )}
    </div>
  );
}

export default function OneDashPanel({ token, theme }) {
  const [rows, setRows]      = useState(SERVERS.map(s=>({...s,m:null,sv:null,rs:null,avgCpu:null,avgRam:null,loading:true})));
  const [updated, setUpdated] = useState(null);
  const H = { "X-Auth-Token": token };

  const loadAll = useCallback(async () => {
    setUpdated(new Date().toLocaleTimeString());
    await Promise.all(SERVERS.map(async (srv, i) => {
      let m=null, sv=null, hist=null, rs=null;
      try {
        const rsUrl = srv.type==="db" ? `${BASE}${srv.base}/rs` : null;
        [m, sv, hist] = await Promise.all([
          fetch(`${BASE}${srv.base}/metrics`,  {headers:H}).then(r=>r.ok?r.json():null).catch(()=>null),
          fetch(`${BASE}${srv.base}/services`, {headers:H}).then(r=>r.ok?r.json():null).catch(()=>null),
          fetch(`${BASE}/metrics-api/history/servers?server=${srv.hkey}&hours=168`, {headers:H}).then(r=>r.ok?r.json():null).catch(()=>null),
        ]);
        if (rsUrl) {
          try { const rsr = await fetch(rsUrl,{headers:H}); rs = rsr.ok ? await rsr.json() : null; } catch(e){}
        }
      } catch(e) {}
      let avgCpu=null, avgRam=null;
      if (Array.isArray(hist) && hist.length > 0) {
        avgCpu = Math.round(hist.reduce((a,x)=>a+x.cpu,0)/hist.length * 10)/10;
        avgRam = Math.round(hist.reduce((a,x)=>a+x.ram,0)/hist.length * 10)/10;
      }
      setRows(prev=>{const n=[...prev];n[i]={...srv,m,sv,rs,avgCpu,avgRam,loading:false};return n;});
    }));
  }, [token]);

  useEffect(()=>{
    loadAll();
    const t = setInterval(loadAll, REFRESH);
    return ()=>clearInterval(t);
  }, [loadAll]);

  const bg   = theme?.bg       || "#0d1117";
  const card = theme?.bgCard   || "#111827";
  const bdr  = theme?.border   || "#1f2937";
  const txt  = theme?.text     || "#e5e7eb";
  const muted= theme?.textMuted|| "#6b7280";

  const thS = {padding:"7px 10px",fontSize:11,fontWeight:600,color:muted,
    textAlign:"left",borderBottom:`1px solid ${bdr}`,whiteSpace:"nowrap",letterSpacing:".05em"};
  const tdS = {padding:"6px 10px",fontSize:12,borderBottom:`1px solid ${bdr}`,verticalAlign:"middle",color:txt};

  const totalSvcs = rows.reduce((a,r)=>a+(r.sv?.summary?.total||0),0);
  const totalRun  = rows.reduce((a,r)=>a+(r.sv?.summary?.running||0),0);
  const totalStop = rows.reduce((a,r)=>a+(r.sv?.summary?.stopped||0),0);
  const totalCPU  = rows.reduce((a,r)=>a+r.specs.cpu,0);
  const totalRAM  = rows.reduce((a,r)=>a+r.specs.ram,0);
  const totalDisk = rows.reduce((a,r)=>a+r.specs.disk,0);
  const avgCPU    = rows.filter(r=>r.m?.cpu).length > 0
    ? (rows.filter(r=>r.m?.cpu).reduce((a,r)=>a+(r.m.cpu.percent||0),0)/rows.filter(r=>r.m?.cpu).length).toFixed(1)
    : "--";
  const avgRAM    = rows.filter(r=>r.m?.ram).length > 0
    ? (rows.filter(r=>r.m?.ram).reduce((a,r)=>a+(r.m.ram.percent||0),0)/rows.filter(r=>r.m?.ram).length).toFixed(1)
    : "--";

  return (
    <div style={{background:bg,minHeight:"100vh",padding:16,fontFamily:"'Inter',sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
        <div>
          <div style={{fontSize:16,fontWeight:700,color:txt}}>OneDash -- Server Overview</div>
          <div style={{fontSize:11,color:muted,marginTop:2}}>
            All servers · Auto-refresh 30s{updated && <span style={{marginLeft:8}}>· Updated {updated}</span>}
          </div>
        </div>
        <button onClick={loadAll} style={{
          background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.3)",
          color:"#6366f1",borderRadius:6,padding:"5px 12px",cursor:"pointer",
          fontSize:12,fontWeight:600,fontFamily:"'Inter',sans-serif"
        }}>Refresh</button>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14}}>
        {[["Servers",rows.length],["Services",totalSvcs||"--"],["Running",totalRun||"--"],["Stopped",totalStop||"--"]].map(([l,v],i)=>(
          <div key={i} style={{background:card,borderRadius:8,padding:"10px 14px",textAlign:"center",border:`1px solid ${bdr}`}}>
            <div style={{fontSize:20,fontWeight:700,color:i===3&&v>0?"#E24B4A":txt}}>{v}</div>
            <div style={{fontSize:11,color:muted,marginTop:2}}>{l}</div>
          </div>
        ))}
      </div>

      <div style={{overflowX:"auto",borderRadius:8,border:`1px solid ${bdr}`}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"rgba(255,255,255,0.03)"}}>
              <th style={{...thS,width:28}}>#</th>
              <th style={thS}>Server</th>
              <th style={thS}>CPU</th>
              <th style={thS}>CPU Use</th>
              <th style={thS}>RAM</th>
              <th style={thS}>RAM Use</th>
              <th style={thS}>Disk</th>
              <th style={thS}>7d Avg CPU/RAM</th>
              <th style={thS}>Capacity</th>
              <th style={thS}>Applications</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r,i) => {
              const isDb = r.type==="db";
              return (
                <tr key={i} style={{background:i%2===0?"transparent":"rgba(255,255,255,0.01)"}}>
                  <td style={{...tdS,color:muted,fontSize:11}}>{r.no}</td>
                  <td style={tdS}>
                    <div style={{fontWeight:600,fontSize:12,color:txt,display:"flex",alignItems:"center",gap:5}}>
                      {isDb && <span style={{fontSize:10,padding:"1px 5px",borderRadius:4,background:"rgba(56,189,248,0.1)",border:"0.5px solid rgba(56,189,248,0.3)",color:"#38bdf8"}}>DB</span>}
                      {r.name}
                    </div>
                    <div style={{fontSize:10,color:muted,marginTop:1}}>{r.ip}</div>
                  </td>
                  <td style={{...tdS,color:muted}}>{r.specs.cpu}c</td>
                  <td style={tdS}>{r.loading ? <span style={{color:"#555",fontSize:11}}>loading</span> : <Pct val={r.m?.cpu?.percent??null}/>}</td>
                  <td style={{...tdS,fontSize:11,color:muted}}>
                    {r.m?.ram ? `${(r.m.ram.used_mb/1024).toFixed(1)}/${r.specs.ram}GB` : `--/${r.specs.ram}GB`}
                  </td>
                  <td style={tdS}>{r.loading ? <span style={{color:"#555",fontSize:11}}>loading</span> : <Pct val={r.m?.ram?.percent??null}/>}</td>
                  <td style={tdS}><DiskCell m={r.m}/></td>
                  <td style={tdS}>
                    {r.avgCpu!=null ? (
                      <div style={{fontSize:11}}>
                        <div><span style={{color:muted}}>CPU </span><span style={{fontWeight:600,color:cls(r.avgCpu)}}>{r.avgCpu}%</span></div>
                        <div><span style={{color:muted}}>RAM </span><span style={{fontWeight:600,color:cls(r.avgRam)}}>{r.avgRam}%</span></div>
                      </div>
                    ) : <span style={{color:"#555",fontSize:11}}>--</span>}
                  </td>
                  <td style={tdS}>
                    {r.avgCpu!=null ? (() => {
                      const score = Math.max(r.avgCpu||0, r.avgRam||0);
                      if (score < 30) return <span style={{fontSize:11,padding:"2px 8px",borderRadius:6,background:"rgba(29,158,117,0.15)",border:"0.5px solid rgba(29,158,117,0.4)",color:"#1D9E75",fontWeight:600}}>Available</span>;
                      if (score < 70) return <span style={{fontSize:11,padding:"2px 8px",borderRadius:6,background:"rgba(239,159,39,0.15)",border:"0.5px solid rgba(239,159,39,0.4)",color:"#EF9F27",fontWeight:600}}>Moderate</span>;
                      return <span style={{fontSize:11,padding:"2px 8px",borderRadius:6,background:"rgba(226,75,74,0.15)",border:"0.5px solid rgba(226,75,74,0.4)",color:"#E24B4A",fontWeight:600}}>High Load</span>;
                    })() : <span style={{color:"#555",fontSize:11}}>--</span>}
                  </td>
                  <td style={tdS}>
                    {isDb && r.rs?.members ? (
                      <div style={{display:"flex",flexDirection:"column",gap:3}}>
                        <div style={{fontSize:10,color:muted,marginBottom:2,fontWeight:600}}>MongoDB Cluster · {r.rs.rs_name||"tanprod"}</div>
                        {(() => {
                          const myIp = r.ip;
                          const myMember = r.rs.members.find(m=>m.name.startsWith(myIp));
                          const sc = myMember?.state==="PRIMARY"?"#6366f1":myMember?.state==="SECONDARY"?"#1D9E75":myMember?.state==="ARBITER"?"#f59e0b":"#888";
                          return (
                            <div style={{fontSize:11,display:"flex",alignItems:"center",gap:5}}>
                              <span style={{padding:"2px 7px",borderRadius:4,background:sc+"20",border:"0.5px solid "+sc+"60",color:sc,fontWeight:700,fontSize:11}}>{myMember?.state||"UNKNOWN"}</span>
                              {myMember?.lag_secs!=null && <span style={{color:"#f59e0b",fontSize:10}}>lag:{myMember.lag_secs}s</span>}
                              <span style={{color:myMember?.health===1?"#1D9E75":"#E24B4A",fontSize:12}}>{myMember?.health===1?"healthy":"down"}</span>
                            </div>
                          );
                        })()}
                      </div>
                    ) : <AppPills services={r.sv?.services}/>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{marginTop:12,padding:"10px 14px",background:"rgba(255,255,255,0.03)",
        borderRadius:8,border:`1px solid ${bdr}`,display:"grid",
        gridTemplateColumns:"repeat(7,1fr)",gap:8,textAlign:"center"}}>
        {[
          ["Total Servers", rows.length],
          ["Total vCPU", totalCPU+"c"],
          ["Total RAM", totalRAM+"GB"],
          ["Total Disk (spec)", totalDisk+"GB"],
          ["Avg CPU Now", avgCPU+"%"],
          ["Avg RAM Now", avgRAM+"%"],
          ["Services", `${totalRun}/${totalSvcs}`],
        ].map(([l,v],i) => (
          <div key={i}>
            <div style={{fontSize:13,fontWeight:600,color:txt}}>{v}</div>
            <div style={{fontSize:10,color:muted,marginTop:2}}>{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
